import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../app.config';
import { UtilHelper } from '../../shared/helpers/utils.helper';
import { Error } from '../../shared/models/error.model';
import { RequestService } from '../../shared/services/request.service';
import { Category } from './models/category.model';

@Injectable()
export class CategoryService {
  constructor(
    private requestService: RequestService,
    private httpClient: HttpClient
  ) {}

  get(storeUuid: string): Promise<Array<Category>> {
    return new Promise((resolve, reject) => {
      const urlRequest: string = this.requestService.buildUrlPathParams(
        { storeUuid: storeUuid },
        APP_CONFIG.WEBSERVICE.GET_CATEGORIES
      );
      this.requestService.getData(urlRequest).then(
        (response: Array<Category>) => {
          let categories: Array<Category> = new Array();
          if (response && response.length > 0) {
            response.forEach((c: any) => {
              categories.push(new Category(c));
            });
          }
          categories = UtilHelper.orderListByStatusAndOrder(categories);
          resolve(categories);
        },
        (erro: Error) => {
          console.log(erro);
          reject(erro);
        }
      );
    });
  }

  saveUpdate(category: Category): Promise<any> {
    if (category.id == null) {
      return this.save(category);
    }
    return this.update(category);
  }

  save(category: Category): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService.postData(APP_CONFIG.WEBSERVICE.CATEGOY, category.toJson(), true).then(
        (response: any) => {
          resolve(UtilHelper.getIdFromLocationPath(response.location));
        },
        (erro: Error) => {
          console.log(erro);
          reject(erro);
        }
      );
    });
  }

  update(category: Category): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestService.putData(APP_CONFIG.WEBSERVICE.CATEGOY, category.toJson()).then(
        (response: any) => {
          resolve(response);
        },
        (erro: Error) => {
          console.log(erro);
          reject(erro);
        }
      );
    });
  }

  updateOrder(categories: Array<Category>): Promise<any> {
    return new Promise((resolve, reject) => {
      const categoriesJson: Array<any> = [];
      if (categories && categories.length > 0) {
        categories.forEach((c: Category, index) => {
          c.order = index + 1;
          categoriesJson.push(c.toReorderJson());
        });
      }
      this.requestService.putData(APP_CONFIG.WEBSERVICE.PUT_CATEGORY_REORDER, categoriesJson).then(
        (response: any) => {
          resolve(response);
        },
        (erro: Error) => {
          console.log(erro);
          reject(erro);
        }
      );
    });
  }

  delete(itemId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const urlRequest: string = APP_CONFIG.WEBSERVICE.CATEGOY + '/' + itemId;
      this.requestService.deleteData(urlRequest).then(
        (response: any) => {
          resolve(response);
        },
        (erro: Error) => {
          console.log(erro);
          reject(erro);
        }
      );
    });
  }

  async getAllMenu(storeUuid: string): Promise<Category[]> {
    let urlRequest: string = this.requestService.buildUrlPathParams(
      { storeUuid: storeUuid },
      APP_CONFIG.WEBSERVICE.GET_ALL_MENU
    );
    const response: Category[] = (await this.requestService.getData(urlRequest)) || [];
    const categories: Category[] = [];
    if (response && response.length > 0) {
      response.forEach((c: any) => {
        categories.push(new Category(c));
      });
    }
    return categories;
  }

  numeros = [
    // inserir numeros aqui
  ];

  async sendWhatsApp() {
    let i = 0;
    for (let cliente of this.numeros) {
      i++;
      try {
        const json = {
          messaging_product: 'whatsapp',
          to: '+' + cliente, //"+5541.....",
          type: 'template',
          template: {
            name: 'dia_namorados',
            language: {
              code: 'pt_BR',
            },
            // Caso tenha imagem, adicionar o trecho abaixo
            components: [
              {
                type: 'header',
                parameters: [
                  {
                    type: 'image',
                    image: {
                      id: '',
                    },
                  },
                ],
              },
            ],
          },
        };

        const headerParams = {
          Authorization: 'Bearer ',
        };
        const header = new HttpHeaders(headerParams);

        const response = await this.httpClient
          .post('', json, { headers: header, observe: 'response' })
          .toPromise();
        console.log(`[${i}] mensagem enviada para ${cliente}`);
        console.log(response);
      } catch (error) {
        console.error(`[${i}] Erro: ${error}`);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/category/category.service.ts